module.exports = __webpack_public_path__ + "static/FooterLogo-5d0a431d405296eaffd631494da749b0.png";